<template>
  <div
    id="app"
  >
    <router-view />
    <tk-global :components="components"></tk-global>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      components: [
        {
          name: 'toast',
          component: 'tk-toast'
        }
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
